/*
 * Copyright © 2017-2026 Knowledge for Decisions (K4D). All rights reserved.
 *
 * This code and associated materials are protected by copyright laws and
 * international treaties. Unauthorized use, reproduction, distribution, or
 * modification of any content from Knowledge for Decisions (K4D) is strictly
 * prohibited. For inquiries regarding the use or licensing of K4D's
 * copyrighted materials, please contact us at contact@k4d.com.br. "Knowledge
 * for Decisions (K4D)" and the slogan "Using data to make precise decisions"
 * are registered trademarks of Knowledge for Decisions (K4D).
 */

import {
  PersonIcon,
  LockClosedIcon,
  GearIcon,
  ChatBubbleIcon,
  QuestionMarkCircledIcon,
} from '@/shared/ui/radix-icons';
import type { UserNavItem } from './user-nav.types';
import { FF_APP_WHATSAPP } from '@shared/utils/feature-flag';

const DESKTOP_ICON = 20;
const MOBILE_ICON = 23;

/**
 * Single source of truth for user-settings navigation. Add or remove an item
 * here and both desktop sidebar and mobile tab bar update consistently.
 */
export const USER_NAV_ITEMS: UserNavItem[] = [
  {
    id: 'profile',
    segment: 'profile',
    labelKey: 'nav.profile',
    icon: <PersonIcon width={DESKTOP_ICON} height={DESKTOP_ICON} />,
    mobileIcon: <PersonIcon width={MOBILE_ICON} height={MOBILE_ICON} />,
    desktopOrder: 0,
    desktopPlacement: 'nav',
    mobileOrder: 0,
    mobilePlacement: 'tab',
  },
  {
    id: 'security',
    segment: 'security',
    labelKey: 'nav.security',
    icon: <LockClosedIcon width={DESKTOP_ICON} height={DESKTOP_ICON} />,
    mobileIcon: <LockClosedIcon width={MOBILE_ICON} height={MOBILE_ICON} />,
    desktopOrder: 1,
    desktopPlacement: 'nav',
    mobileOrder: 1,
    mobilePlacement: 'tab',
  },
  {
    id: 'whatsapp',
    segment: 'whatsapp',
    labelKey: 'nav.whatsapp',
    icon: <ChatBubbleIcon width={DESKTOP_ICON} height={DESKTOP_ICON} />,
    mobileIcon: <ChatBubbleIcon width={MOBILE_ICON} height={MOBILE_ICON} />,
    desktopOrder: 2,
    desktopPlacement: 'nav',
    mobileOrder: 2,
    mobilePlacement: 'center',
    isEnabled: () => FF_APP_WHATSAPP,
  },
  {
    id: 'preferences',
    segment: 'preferences',
    labelKey: 'nav.preferences',
    icon: <GearIcon width={DESKTOP_ICON} height={DESKTOP_ICON} />,
    mobileIcon: <GearIcon width={MOBILE_ICON} height={MOBILE_ICON} />,
    desktopOrder: 3,
    desktopPlacement: 'nav',
    mobileOrder: 3,
    mobilePlacement: 'tab',
  },
  {
    id: 'help',
    segment: 'help',
    labelKey: 'nav.help',
    icon: <QuestionMarkCircledIcon width={DESKTOP_ICON} height={DESKTOP_ICON} />,
    mobileIcon: <QuestionMarkCircledIcon width={MOBILE_ICON} height={MOBILE_ICON} />,
    desktopOrder: 4,
    desktopPlacement: 'nav',
    mobileOrder: 4,
    mobilePlacement: 'tab',
  },
];
